// TitleManager.tsx
import { useEffect } from 'react'
import { matchRoutes, useLocation } from 'react-router-dom'
import routes from '@/routes'

const MAX_TITLE_LEN = 150

export function formatTitle(...parts: string[]) {
  const s = 'Workforce / ' + parts.join(' / ')
  if (s.length <= MAX_TITLE_LEN) return s
  return s.slice(0, Math.max(0, MAX_TITLE_LEN - 3)).trimEnd() + '...'
}

type WithTitle = { title: string }

export function TitleManager() {
  const location = useLocation()

  useEffect(() => {
    const matches = matchRoutes(routes, location) ?? []

    // Find the deepest matched route that provides a title
    const lastWithTitle = [...matches].reverse().find(m => (m.route.handle as WithTitle | undefined)?.title)

    if (!lastWithTitle) {
      document.title = 'Workforce'
      return
    }

    const title = (lastWithTitle.route.handle as WithTitle).title
    document.title = formatTitle(title)
  }, [location])

  return null
}
